import { render, staticRenderFns } from "./Productdescriptiontabs.vue?vue&type=template&id=fe0f3234&"
import script from "./Productdescriptiontabs.vue?vue&type=script&lang=ts&"
export * from "./Productdescriptiontabs.vue?vue&type=script&lang=ts&"
import style0 from "./Productdescriptiontabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports